module.exports = __webpack_public_path__ + "static/media/shopping-webfont.cb1d1196.woff2";